(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Delivery_status', Delivery_status);

    Delivery_status.$inject = ['$resource'];

    function Delivery_status ($resource) {
        var resourceUrl =  'api/delivery-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
